import Reveal from "@/components/Reveal";

const Chapter = ({ index, eyebrow, title, description, dark = false, center = false }) => (
  <Reveal className={center ? "text-center" : ""}>
    <div className={`flex items-baseline gap-4 ${center ? "justify-center" : ""}`}>
      <span className="font-serif text-sm italic text-gold">{index}</span>
      <span className={`text-xs font-semibold uppercase tracking-[0.3em] ${dark ? "text-champagne" : "text-royal"}`}>
        {eyebrow}
      </span>
    </div>
    <h2
      data-testid={`chapter-title-${index}`}
      className={`mt-4 font-serif text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl ${
        dark ? "text-white" : "text-navy"
      }`}
    >
      {title}
    </h2>
    <div className={`gold-hairline mt-6 w-40 ${center ? "mx-auto" : ""}`} />
    {description && (
      <p className={`mt-6 max-w-2xl text-base leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"} ${center ? "mx-auto" : ""}`}>
        {description}
      </p>
    )}
  </Reveal>
);

export default Chapter;
